import type { ReactNode } from "react";

import { HoverHintTrigger } from "@/components/ui/title-help";

import { EntityPeekHint } from "./EntityPeekHint";
import type { EntityPeekProps } from "./entityPeekTypes";

/** Wraps a detail link (or any trigger) with the universal entity peek-through. */
export function DetailLinkWithEntityPeek({
  trigger,
  peek,
  align = "start",
  block = false,
  className,
  closeOnTriggerActivate,
}: {
  trigger: ReactNode;
  peek?: EntityPeekProps;
  align?: "center" | "start";
  block?: boolean;
  className?: string;
  closeOnTriggerActivate?: boolean;
}): ReactNode {
  if (peek == null) {
    return trigger;
  }
  return (
    <HoverHintTrigger
      align={align}
      block={block}
      className={className}
      closeOnTriggerActivate={closeOnTriggerActivate}
      trigger={trigger}
    >
      <EntityPeekHint {...peek} />
    </HoverHintTrigger>
  );
}
